import React from 'react';
import ShoppingCart from '../../utils/shoppingCart';
import Button from '../common/Button';

const AddToCartButton = props => {
  return (
    <Button
      className="w-full"
      iconClass="fas fa-cart-minus"
      onClick={() => {
        ShoppingCart.removeShoppingCartCard(props.card);
        if (props.onRemoveCardFromCart) props.onRemoveCardFromCart();
      }}>
      Eliminar del carrito
    </Button>
  );
};

export default AddToCartButton;
